import { render, staticRenderFns } from "./sendPageCQ.vue?vue&type=template&id=320fb032&"
import script from "./sendPageCQ.vue?vue&type=script&lang=js&"
export * from "./sendPageCQ.vue?vue&type=script&lang=js&"
import style0 from "./sendPageCQ.vue?vue&type=style&index=0&id=320fb032&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports